import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MetaVerifiedBadge } from "../../components/MetaVerifiedBadge";

/**
 * Shared frame for the three E-E-A-T compliance pages: Privacy, Terms, Contact.
 * Matches the Landing's dark-neon aesthetic so users land coherently.
 */
export default function LegalLayout({ eyebrow, title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-bone text-white" data-testid={testid}>
      <header className="fixed top-0 w-full z-50 backdrop-blur-2xl bg-bone/80 border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo">
            <div className="w-10 h-10 rounded-xl overflow-hidden bg-obsidian shrink-0 flex items-center justify-center">
              <img src="/instavibe-logo.jpg" alt="InstaVibe" className="w-full h-full object-cover scale-[1.35]" />
            </div>
            <div className="font-heading font-black text-2xl tracking-tighter leading-none">
              InstaVibe<span className="text-klein">.</span>
            </div>
          </Link>
          <Link to="/" className="btn-ghost text-sm" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="pt-32 pb-24 px-6 md:px-12 max-w-[820px] mx-auto">
        <div className="overline mb-4">— {eyebrow}</div>
        <h1 className="font-heading font-black text-4xl md:text-5xl tracking-tighter leading-none mb-6" data-testid="legal-title">
          {title}
        </h1>
        {lastUpdated && (
          <div className="text-sm text-white/50 font-mono mb-12">Last updated: {lastUpdated}</div>
        )}
        <article className="prose-legal space-y-6 text-white/80 leading-relaxed">
          {children}
        </article>
      </main>

      <footer className="border-t border-white/10 py-10 px-6 md:px-12 max-w-[1400px] mx-auto flex flex-wrap gap-6 justify-between items-center text-sm text-white/60">
        <div>© 2026 InstaVibe. Not affiliated with Meta.</div>
        <MetaVerifiedBadge variant="compact" />
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <Link to="/contact" className="hover:text-white">Contact</Link>
        </div>
      </footer>
    </div>
  );
}
